export const ToggleViewBoxSize = [180, 100];
export const ToggleRemSize = 1.25;
